export default __webpack_public_path__ + "static/media/CountDownTracker-Thumbnail.ac3b96d6.png";